import { ShardSearchEntry } from '../@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetShardCatalogSearchRequest = {
	query: string;
	limit?: number;
    type?: string;
};

export type GetShardCatalogSearchResponse = Array<ShardSearchEntry>;

export const getShardCatalogSearch = createGetEndpoint<GetShardCatalogSearchRequest, GetShardCatalogSearchResponse>(
	(request) =>
		`/api/v3/core/search/shard-catalog?${getQueryString({
			limit: request?.limit ?? 20,
			q: request?.query,
			type: request?.type
		})}`,
	{
		skipAuthRefresh: true
	}
);
